import React, { FunctionComponent } from "react";
import { Router, Switch } from "react-router-dom";

import AdGroupSelectionPanel from "../views/redesign/AdGroupSelectionPanel";
import AdGroupSelectionSlide from "../views/CampaignCreationBasicSlides/AdGroupSelectionSlide";
import AdministrationPage from "../pages/AdministrationPage";
import AdvertiserDashboardPage from "../pages/AdvertiserDashboardPage/AdvertiserDashboardPage";
import AdvertiserDetailPage from "../pages/AdvertiserDetailPage";
import AdvertiserSettingsPage from "../pages/AdvertiserSettingsPage/AdvertiserSettingsPage";
import AdvertisersListPage from "../pages/AdvertisersListPage";
import AdvertisersPage from "../pages/AdvertisersPage/AdvertisersPage";
import AllBillingLogsPage from "../pages/AllBillingLogsPage";
import AuthGuardRoute from "./AuthGuardRoute";
import AuthManagementRoute from "./AuthManagementRoute";
import CRMRetargetinSegmentsPage from "../pages/CRMRetargetingSegmentsPage";
import CRMRetargetingSegmentsView from "../views/redesign/CRMRetargetingSegments";
import CampaignDetailPage from "../pages/CampaignDetailPage";
import CampaignFromTemplateCreatePage from "../pages/CampaignFromTemplateCreatePage";
import CampaignFromTemplateCreatePageRedesign from "../pages/CampaignFromTemplateCreatePage/CampaignFromTemplateCreatePageRedesign";
import CampaignTemplateCreatePage from "../pages/CampaignTemplateCreatePage";
import CampaignTemplateCreatePageRedesign from "../pages/CampaignTemplateCreatePage/CampaignTemplateCreatePageRedesign";
import CampaignTemplateEditPageRedesign from "../pages/CampaignTemplateCreatePage/CampaignTemplateEditPageRedesign";
import CampaignTemplatesPage from "../pages/CampaignTemplatesPage";
import CampaignTemplatesPageRedesign from "../pages/CampaignTemplatesPage/CampaignTemplatesPageRedesign";
import ContextualAbmCreatePageRedesign from "../pages/ContextualAbmCreatePage/ContextualAbmCreatePageRedesign";
import ContextualMediaBuyingCreatePageRedesign from "../pages/ContextualMediaBuyingCreatePage/ContextualMediaBuyingCreatePageRedesign";
import ContextualPersonaCreatePageRedesign from "../pages/ContextualPersonaCreatePage/ContextualPersonaCreatePageRedesign";
import CrmRetargetingCreatePageRedesign from "../pages/CrmRetargetingCreatePage/CrmRetargetingCreatePageRedesign";
import CustomCampaignCreatePageRedesign from "../pages/CustomCampainCreatePage/CustomCampaignCreatePageRedesign";
import CustomCampainCreatePage from "../pages/CustomCampainCreatePage";
import DashboardPage from "../pages/DashboardPage";
import DashboardRedirect from "../pages/DashboardPage/DashboardRedirect";
import ForgotPasswordPage from "../pages/ForgotPasswordPage";
import GeoTargetingCreatePageRedesign from "../pages/GeoTargetingCreatePage/GeoTargetingCreatePageRedesign";
import InvoicesPage from "../pages/InvoicesPage";
import ManagedCampaignCreatePage from "../pages/ManagedCampaignCreatePage";
import ManagedCampaignCreatePageRedesign from "../pages/ManagedCampaignCreatePage/ManagedCampaignCreatePageRedesign";
import PersonaRetargetingCreatePageRedesign from "../pages/PersonaRetargetingCreatePage/PersonaRetargetingCreatePageRedesign";
import PrivacyPage from "../pages/LegalDocsPage/PrivacyPage";
import PublicCampaignPicker from "../containers/PublicCampaignPicker";
import PublicRoute from "./PublicRoute";
import PublicationListSelectionSlide from "../views/CampaignCreationCustomSlides/PublicationListSelectionSlide";
import PublicationListsView from "../views/redesign/PublicationListsView/PublicationListsView";
import RoleTitleSelectionSlide from "../views/CampaignCreationBasicSlides/RoleTitleSelectionSlide";
import RolesTitlesView from "../views/redesign/RolesTitlesView";
import SegmentsLogsPage from "../pages/SegmentsLogsPage";
import SelectHubspotTargetCompaniesSlide from "../views/CampaignCreationBasicSlides/SelectHubspotTargetCompaniesSlide";
import SignInPage from "../pages/SignInPage";
import SignUpPage from "../pages/SignUpPage";
import SiteRetargetingCreatePageRedesign from "../pages/SiteRetargetingCreatePage/SiteRetargetingCreatePageRedesign";
import StateProvinceSetsView from "../views/redesign/StateProvinceView/StateProvinceSetsView";
import StateProvinceView from "../views/redesign/StateProvinceView/StateProvinceView";
import TargetCompaniesView from "../views/redesign/TargetCompaniesView";
import TermsOfUse from "../pages/LegalDocsPage/TermsOfUse";
import TraditionalAbmCreatePageRedesign from "../pages/TraditionalAbmCreatePage/TraditionalAbmCreatePageRedesign";
import VisitorsRetargetinSegmentsPage from "../pages/VisitorsRetargetingSegmentsPage";
import VisitorsRetargetingSegmentsView from "../views/redesign/VisitorsRetargetingSegments/VisitorsRetargetingSegmentsView";
import ZipCodeSelectionSlide from "../views/CampaignCreationCustomSlides/ZipCodeSelectionSlide";
import ZipCodesView from "../views/redesign/ZipCodesView";
import { ROUTE_PATHS } from "../types/RoutePaths";
import { history } from "../sentry";

const featureNewDesign = process.env.REACT_APP_FEATURE_NEW_DESIGN === "true";

const Routes: FunctionComponent = () => {
  return (
    <Router history={history}>
      <Switch>
        <AuthManagementRoute path={`${ROUTE_PATHS.ROOT}`} exact component={SignInPage} />
        <AuthManagementRoute path={`${ROUTE_PATHS.SIGNUP}`} exact component={SignUpPage} />
        <AuthManagementRoute path={`${ROUTE_PATHS.FORGOT_PASSWORD}`} exact component={ForgotPasswordPage} />
        {featureNewDesign ? (
          <AuthGuardRoute path={`${ROUTE_PATHS.DASHBOARD}`} exact component={DashboardRedirect} useNewLayout title="" />
        ) : (
          <AuthGuardRoute path={`${ROUTE_PATHS.DASHBOARD}`} exact component={DashboardPage} />
        )}
        {featureNewDesign ? (
          <AuthGuardRoute
            path={ROUTE_PATHS.ADVERTISER_CAMPAIGN_DETAIL}
            exact
            component={CampaignDetailPage}
            useNewLayout
            title="Campaign"
            subtitle=""
          />
        ) : null}
        {featureNewDesign ? (
          <AuthGuardRoute
            path={`${ROUTE_PATHS.ADVERTISERS_LIST}`}
            exact
            component={AdvertisersPage}
            useNewLayout
            title="Manage Advertisers"
            subtitle="Your advertiser accounts and performance overview"
          />
        ) : (
          <AuthGuardRoute path={`${ROUTE_PATHS.ADVERTISERS_LIST}`} exact component={AdvertisersListPage} />
        )}
        {featureNewDesign ? (
          <AuthGuardRoute
            path={ROUTE_PATHS.ADVERTISER_DASHBOARD}
            exact
            component={AdvertiserDashboardPage}
            useNewLayout
            title="Dashboard"
            subtitle=""
          />
        ) : null}
        {featureNewDesign ? (
          <AuthGuardRoute
            path={ROUTE_PATHS.ADVERTISER_DETAIL}
            exact
            component={AdvertiserSettingsPage}
            useNewLayout
            title="Advertiser Settings"
            subtitle=""
          />
        ) : (
          <AuthGuardRoute path={ROUTE_PATHS.ADVERTISER_DETAIL} exact component={AdvertiserDetailPage} />
        )}
        {featureNewDesign ? (
          <AuthGuardRoute
            path={ROUTE_PATHS.ADMINISTRATION_CAMPAIGN_DETAIL}
            exact
            component={CampaignDetailPage}
            useNewLayout
            title="Campaign"
            subtitle=""
            adminOnly
          />
        ) : null}
        {featureNewDesign ? (
          <AuthGuardRoute
            path={ROUTE_PATHS.ADMINISTRATION_ADVERTISER}
            exact
            component={AdvertiserDashboardPage}
            useNewLayout
            title="Advertiser Campaigns"
            subtitle=""
            adminOnly
          />
        ) : null}
        {featureNewDesign ? (
          <AuthGuardRoute
            path={ROUTE_PATHS.ADMINISTRATION}
            exact
            component={AdministrationPage}
            useNewLayout
            title="Administration"
            subtitle="All advertisers and campaigns across the platform"
            adminOnly
          />
        ) : null}
        <AuthGuardRoute path={`${ROUTE_PATHS.ALLBILLINGLOGS}`} exact component={AllBillingLogsPage} />
        <AuthGuardRoute path={`${ROUTE_PATHS.INVOICES}`} exact component={InvoicesPage} />
        {featureNewDesign ? (
          <AuthGuardRoute
            path={`${ROUTE_PATHS.MANAGED_CAMPAIGN_CREATE}`}
            exact
            component={ManagedCampaignCreatePageRedesign}
            useNewLayout
            title="Managed Services"
            subtitle=""
          />
        ) : (
          <AuthGuardRoute path={`${ROUTE_PATHS.MANAGED_CAMPAIGN_CREATE}`} exact component={ManagedCampaignCreatePage} />
        )}
        {featureNewDesign ? (
          <AuthGuardRoute
            path={`${ROUTE_PATHS.CUSTOM_CAMPAIGN_CREATE}`}
            exact
            component={CustomCampaignCreatePageRedesign}
            useNewLayout
            title="Custom Campaign"
            subtitle="Build a Campaign with Custom Targeting"
          />
        ) : (
          <AuthGuardRoute path={`${ROUTE_PATHS.CUSTOM_CAMPAIGN_CREATE}`} exact component={CustomCampainCreatePage} />
        )}
        {featureNewDesign ? (
          <AuthGuardRoute
            path={`${ROUTE_PATHS.VISITORS_RE_TARGETING_SEGMENTS}`}
            exact
            component={VisitorsRetargetingSegmentsView}
            useNewLayout
            title="Visitors Retargeting Segments"
          />
        ) : (
          <AuthGuardRoute
            path={`${ROUTE_PATHS.VISITORS_RE_TARGETING_SEGMENTS}`}
            exact
            component={VisitorsRetargetinSegmentsPage}
          />
        )}
        {featureNewDesign ? (
          <AuthGuardRoute
            path={`${ROUTE_PATHS.CRM_RE_TARGETING_SEGMENTS}`}
            exact
            component={CRMRetargetingSegmentsView}
            useNewLayout
            title="CRM Re-targeting Segments"
          />
        ) : (
          <AuthGuardRoute
            path={`${ROUTE_PATHS.CRM_RE_TARGETING_SEGMENTS}`}
            exact
            component={CRMRetargetinSegmentsPage}
          />
        )}
        <PublicRoute path={`${ROUTE_PATHS.PUBLIC_CAMPAIGNS_PICKER}`} exact component={PublicCampaignPicker} />
        <PublicRoute path={`${ROUTE_PATHS.TERMS_PAGE}`} exact component={TermsOfUse} />
        <PublicRoute path={`${ROUTE_PATHS.PRIVACY_PAGE}`} exact component={PrivacyPage} />
        {featureNewDesign ? (
          <AuthGuardRoute
            path={`${ROUTE_PATHS.PUBLICATION_LISTS}`}
            exact
            component={PublicationListsView}
            useNewLayout
            title="Publication Lists"
            subtitle="Manage your publication lists and custom domain sets"
          />
        ) : (
          <AuthGuardRoute path={`${ROUTE_PATHS.PUBLICATION_LISTS}`} exact component={PublicationListSelectionSlide} />
        )}
        {featureNewDesign ? (
          <AuthGuardRoute
            path={`${ROUTE_PATHS.ADS_UPLOAD}`}
            exact
            component={AdGroupSelectionPanel}
            useNewLayout
            title="Ads Upload"
            subtitle="Manage and upload your ad creatives"
          />
        ) : (
          <AuthGuardRoute path={`${ROUTE_PATHS.ADS_UPLOAD}`} exact component={AdGroupSelectionSlide} />
        )}
        {featureNewDesign ? (
          <AuthGuardRoute
            path={`${ROUTE_PATHS.TARGET_COMPANIES}`}
            exact
            component={TargetCompaniesView}
            useNewLayout
            title="Company Match Rates"
          />
        ) : (
          <AuthGuardRoute
            path={`${ROUTE_PATHS.TARGET_COMPANIES}`}
            exact
            component={SelectHubspotTargetCompaniesSlide}
          />
        )}
        {featureNewDesign ? (
          <AuthGuardRoute
            path={`${ROUTE_PATHS.ROLES_AND_TITLES}`}
            exact
            component={RolesTitlesView}
            useNewLayout
            title="Role & Title Sets"
            subtitle="Create reusable role and title groups for campaign targeting"
          />
        ) : (
          <AuthGuardRoute path={`${ROUTE_PATHS.ROLES_AND_TITLES}`} exact component={RoleTitleSelectionSlide} />
        )}
        {featureNewDesign ? (
          <AuthGuardRoute
            path={`${ROUTE_PATHS.STATE_PROVINCE}`}
            exact
            component={StateProvinceSetsView}
            useNewLayout
            title="State & Province Sets"
            subtitle="Create reusable state and province groups for campaign targeting"
          />
        ) : (
          <AuthGuardRoute path={`${ROUTE_PATHS.STATE_PROVINCE}`} exact component={StateProvinceView} />
        )}
        <AuthGuardRoute path={`${ROUTE_PATHS.SEGMENTS_LOGS}`} exact component={SegmentsLogsPage} />
        {featureNewDesign ? (
          <AuthGuardRoute
            path={`${ROUTE_PATHS.ZIP_CODES}`}
            exact
            component={ZipCodesView}
            useNewLayout
            title="Zip Codes"
          />
        ) : (
          <AuthGuardRoute path={`${ROUTE_PATHS.ZIP_CODES}`} exact component={ZipCodeSelectionSlide} />
        )}
        {featureNewDesign ? (
          <AuthGuardRoute
            path={`${ROUTE_PATHS.CAMPAIGN_CREATE_FROM_TEMPLATE}`}
            exact
            component={CampaignFromTemplateCreatePageRedesign}
            useNewLayout
            title="Campaign Creation"
            subtitle="Build a Campaign from a Template"
          />
        ) : (
          <AuthGuardRoute
            path={`${ROUTE_PATHS.CAMPAIGN_CREATE_FROM_TEMPLATE}`}
            exact
            component={CampaignFromTemplateCreatePage}
          />
        )}
        {featureNewDesign ? (
          <AuthGuardRoute
            path={`${ROUTE_PATHS.CREATE_CAMPAIGN_TEMPLATE}`}
            exact
            component={CampaignTemplateCreatePageRedesign}
            useNewLayout
            title="Campaign Template Creation"
            subtitle="Design a Scalable Campaign Template"
          />
        ) : (
          <AuthGuardRoute
            path={`${ROUTE_PATHS.CREATE_CAMPAIGN_TEMPLATE}`}
            exact
            component={CampaignTemplateCreatePage}
          />
        )}
        {featureNewDesign ? (
          <AuthGuardRoute
            path={`${ROUTE_PATHS.CAMPAIGN_TEMPLATES}`}
            exact
            component={CampaignTemplatesPageRedesign}
            useNewLayout
            title="Campaign Templates"
            subtitle="Speed production by leveraging campaign templates and clone campaigns"
          />
        ) : (
          <AuthGuardRoute path={`${ROUTE_PATHS.CAMPAIGN_TEMPLATES}`} exact component={CampaignTemplatesPage} />
        )}
        {featureNewDesign && (
          <AuthGuardRoute
            path={`${ROUTE_PATHS.CAMPAIGN_TEMPLATE_EDIT}`}
            exact
            component={CampaignTemplateEditPageRedesign}
            useNewLayout
            title="Edit Template"
            subtitle="Update your campaign template"
          />
        )}
        {featureNewDesign && (
          <AuthGuardRoute
            path={ROUTE_PATHS.TRADITIONAL_ABM_CREATE}
            exact
            component={TraditionalAbmCreatePageRedesign}
            useNewLayout
            title="Traditional ABA"
            subtitle="Target companies and roles with account-based advertising"
          />
        )}
        {featureNewDesign && (
          <AuthGuardRoute
            path={ROUTE_PATHS.CONTEXTUAL_ABM_CREATE}
            exact
            component={ContextualAbmCreatePageRedesign}
            useNewLayout
            title="Contextual ABA"
            subtitle="Reach target accounts through contextual publication targeting"
          />
        )}
        {featureNewDesign && (
          <AuthGuardRoute
            path={ROUTE_PATHS.CONTEXTUAL_MEDIA_BUYING_CREATE}
            exact
            component={ContextualMediaBuyingCreatePageRedesign}
            useNewLayout
            title="Contextual Media Buying"
            subtitle="Advertise across targeted publication lists"
          />
        )}
        {featureNewDesign && (
          <AuthGuardRoute
            path={ROUTE_PATHS.CONTEXTUAL_PERSONA_CREATE}
            exact
            component={ContextualPersonaCreatePageRedesign}
            useNewLayout
            title="Contextual / Persona Targeting"
            subtitle="Combine publication context with role and title targeting"
          />
        )}
        {featureNewDesign && (
          <AuthGuardRoute
            path={ROUTE_PATHS.GEO_TARGETING_CREATE}
            exact
            component={GeoTargetingCreatePageRedesign}
            useNewLayout
            title="Geo-Targeting"
            subtitle="Target audiences by zip code or state and province"
          />
        )}
        {featureNewDesign && (
          <AuthGuardRoute
            path={ROUTE_PATHS.CRM_RETARGETING_CREATE}
            exact
            component={CrmRetargetingCreatePageRedesign}
            useNewLayout
            title="CRM Retargeting"
            subtitle="Re-engage your CRM contacts with targeted advertising"
          />
        )}
        {featureNewDesign && (
          <AuthGuardRoute
            path={ROUTE_PATHS.SITE_RETARGETING_CREATE}
            exact
            component={SiteRetargetingCreatePageRedesign}
            useNewLayout
            title="Visitor Retargeting"
            subtitle="Re-engage visitors who have browsed your site"
          />
        )}
        {featureNewDesign && (
          <AuthGuardRoute
            path={ROUTE_PATHS.PERSONA_RETARGETING_CREATE}
            exact
            component={PersonaRetargetingCreatePageRedesign}
            useNewLayout
            title="Visitor Persona Retargeting"
            subtitle="Re-engage site visitors filtered by role and title"
          />
        )}
      </Switch>
    </Router>
  );
};

export default Routes;
